{
  "tooltip": {
    "position": "top",
    "formatter": null
  },
  "grid": {
    "height": "100%",
    "width": "100%",
    "left": "0%",
    "right": "0%",
    "top": "75px"
  },
  "xAxis": {
    "type": "category",
    "position": "top",
    "data": [],
    "axisLabel": {
      "rotate": -45,
      "textStyle": {
        "fontWeight": "bold"
      }
    }
  },
  "yAxis": {
    "type": "category",
    "inverse": true,
    "data": [],
    "position": "top"
  },
  "visualMap": {
    "min": 0,
    "max": 10,
    "calculable": true,
    "orient": "horizontal",
    "left": "right",
    "bottom": "0%",
    "color": ["#9c001c", "#b50021", "#690013"]
  },
  "dataZoom": [
    {
      "type": "slider",
      "yAxisIndex": 0,
      "zoomLock": true,
      "width": 10,
      "right": 10,
      "start": 0,
      "end": 100,
      "handleSize": 20,
      "showDataShadow": false,
      "minValueSpan": 1,
      "maxValueSpan": 10
    }
  ],
  "series": [
    {
      "name": "MITRE ATT&CK Heatmap",
      "type": "heatmap",
      "data": [],
      "label": {
        "show": true,
        "formatter": null
      },
      "boxSize": [80, 80]
    }
  ]
}
